import './MarketingSectionIntro.scss';

import classNames from 'classnames';
import type { PropsWithChildren } from 'react';

export type MarketingSectionIntroVariant = 'fvt' | 'hcp' | 'plain';

export interface MarketingSectionIntroProps {
  className?: string;
  eyebrow?: string;
  heading: string;
  headingClassName?: string;
  headingId: string;
  variant: MarketingSectionIntroVariant;
}

export const MarketingSectionIntro = ({
  variant,
  heading,
  headingId,
  eyebrow,
  className,
  headingClassName,
  children,
}: PropsWithChildren<MarketingSectionIntroProps>) => {
  const showsEyebrow = variant !== 'plain';

  return (
    <div className={classNames('marketing-section-intro', `marketing-section-intro--${variant}`, className)}>
      {showsEyebrow && eyebrow && <div className='marketing-section-intro__eyebrow'>{eyebrow}</div>}

      <h2 id={headingId} className={classNames('marketing-section-intro__heading', headingClassName)}>
        {heading}
      </h2>

      {children && <div className='marketing-section-intro__lead'>{children}</div>}
    </div>
  );
};
